// pages/CourseCategory.jsx

import React from "react";
import { Table, Input, Button, Modal, Form, Upload } from "antd";
import {
	PlusOutlined,
	EyeOutlined,
	EditOutlined,
	DeleteOutlined,
} from "@ant-design/icons";
import useCourseCategories from "../../../hooks/AdminDashboard/useCourseCategories";
import { BASE_UPLOADS } from "../../../utils/constants";

function CourseCategory() {
	const {
		form,
		setSearchTerm,
		selectedFile,
		isModalVisible,
		modalType,
		selectedCategory,
		showModal,
		handleModalConfirm,
		handleModalCancel,
		filteredCategories,
	} = useCourseCategories();

	const columns = [
		{ title: "Category Title", dataIndex: "title", key: "title" },
		{ title: "Description", dataIndex: "description", key: "description" },
		{
			title: "Actions",
			key: "actions",
			render: (_, record) => (
				<span className="space-x-2">
					<Button
						icon={<EyeOutlined />}
						onClick={() => showModal("view", record)}
						// className="bg-blue-500 hover:bg-blue-600 text-white"
					/>
					<Button
						icon={<EditOutlined />}
						onClick={() => showModal("edit", record)}
						// className="bg-yellow-500 hover:bg-yellow-600 text-white"
					/>
					<Button
						icon={<DeleteOutlined />}
						onClick={() => showModal("delete", record)}
						danger
						// className="bg-red-500 hover:bg-red-600 text-white"
					/>
				</span>
			),
		},
	];

	// const handleImageChange = (event) => {
	// 	if (event.target.files && event.target.files.length > 0) {
	// 		const file = event.target.files[0];
	// 		setSelectedFile(URL.createObjectURL(file)); // Create a URL for the uploaded file
	// 	}
	// };

	const renderFormContent = () => {
		switch (modalType) {
			case "add":
				return (
					<>
						<Form.Item
							name="title"
							label="Category Title"
							rules={[{ required: true }]}
						>
							<Input />
						</Form.Item>
						<Form.Item
							name="description"
							label="Description"
							rules={[{ required: true }]}
						>
							<Input.TextArea />
						</Form.Item>
						<Form.Item
							name="image"
							label="Category Image"
							valuePropName="file"
							getValueFromEvent={(e) => e.fileList[0]}
							// rules={[{ required: true }]}
						>
							<Upload beforeUpload={() => false} listType="text">
								<input
									type="file"
									accept="image/*"
									// onChange={handleImageChange}
									style={{ display: "none" }}
									id="category-image-input"
									rules={[
										{
											required: true,
											message: "Please upload a file",
										},
									]}
								/>
								<label
									htmlFor="category-image-input"
									className="flex items-center justify-center border-dashed border-2 border-gray-300 rounded-lg h-36 cursor-pointer"
								>
									{selectedFile ? (
										<img
											src={selectedFile}
											alt="Uploaded"
											className="w-full h-full object-cover rounded-lg"
										/>
									) : (
										<>
											<PlusOutlined className="text-4xl text-blue-500" />
											<p className="mt-2 text-sm text-gray-600">
												Upload Image
											</p>
										</>
									)}
								</label>
							</Upload>
						</Form.Item>
					</>
				);
			case "edit":
				return (
					<>
						<Form.Item
							name="title"
							label="Category Title"
							rules={[{ required: true }]}
						>
							<Input />
						</Form.Item>
						<Form.Item
							name="description"
							label="Description"
							rules={[{ required: true }]}
						>
							<Input.TextArea />
						</Form.Item>

						<Form.Item
							name="image"
							label="Category Image"
							getValueFromEvent={(e) => e.fileList[0]}
							// rules={[{ required: true }]}
						>
							<Upload beforeUpload={() => false} listType="text">
								<input
									type="file"
									// onChange={handleImageChange}
									style={{ display: "none" }}
									id="category-image-input"
									accept="image/*"
									rules={[
										{
											required: true,
											message: "Please upload a file",
										},
									]}
								/>
								<label
									htmlFor="category-image-input"
									className="flex items-center justify-center border-dashed border-2 border-gray-300 rounded-lg h-36 cursor-pointer"
								>
									{selectedFile ? (
										<img
											src={selectedFile}
											alt="Uploaded"
											className="w-full h-full object-cover rounded-lg"
										/>
									) : (
										<>
											<PlusOutlined className="text-4xl text-blue-500" />
											<p className="mt-2 text-sm text-gray-600">
												Upload Image
											</p>
										</>
									)}
								</label>
							</Upload>
						</Form.Item>
					</>
				);
			case "view":
				return (
					<div>
						<p>
							<strong>Title:</strong> {selectedCategory.title}
						</p>
						<p>
							<strong>Description:</strong>{" "}
							{selectedCategory.description}
						</p>
						<p>
							<strong>Image:</strong>
						</p>
						<img
							src={`${BASE_UPLOADS}/category-pic/${selectedCategory.image}`}
							alt={selectedCategory.title}
							className="w-full h-auto rounded-lg"
						/>
					</div>
				);
			case "delete":
				return <p>Are you sure you want to delete this category?</p>;
			default:
				return null;
		}
	};

	return (
		<div className="p-6 bg-white">
			<h2 className="text-2xl font-bold mb-4">Course Categories</h2>

			<div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
				<Input.Search
					placeholder="Search by category title..."
					onChange={(e) => setSearchTerm(e.target.value)}
					className="w-full"
				/>
				<Button
					type="primary"
					icon={<PlusOutlined />}
					onClick={() => showModal("add")}
					className="w-full bg-blue-500 hover:bg-blue-600"
				>
					Add Category
				</Button>
			</div>

			<Table
				columns={columns}
				dataSource={filteredCategories}
				rowKey="_id"
				pagination={{ position: ["bottomRight"] }}
				className="w-full"
			/>

			<Modal
				title={`${
					modalType.charAt(0).toUpperCase() + modalType.slice(1)
				} Category`}
				open={isModalVisible}
				onCancel={handleModalCancel}
				footer={null} // Custom footer to handle form submission
			>
				<Form
					layout="vertical"
					onFinish={handleModalConfirm} // Handle submission
					initialValues={
						modalType === "edit" && selectedCategory
							? {
									title: selectedCategory.title,
									description: selectedCategory.description,
							  }
							: {}
					}
					form={form}
					encType="multipart/form-data"
				>
					{renderFormContent()}
					<Form.Item>
						<Button type="primary" htmlType="submit">
							{modalType === "delete" ? "Confirm" : "Submit"}
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	);
}

export default CourseCategory;
